import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { AccountType } from '../types';

import { Action } from './constants';
import { StateType, ActionType } from './types';

export const initialState: StateType = { account: {} as AccountType };

const reducer: Reducer<StateType, ActionType> = produce(
  (draft: Draft<StateType>, action: ActionType) => {
    const { type } = action;
    switch (type) {
      case Action.SET_ACCOUNT: {
        if (!('account' in action)) throw new Error('Account is missing');
        draft.account = action.account;
        break;
      }
      case Action.UPDATE_ACCOUNT_FEATURES: {
        if (!('features' in action)) throw new Error('Features is missing');
        draft.account.features = { ...draft.account.features, ...action.features };
        break;
      }
      case Action.UPDATE_USER: {
        if (!('userId' in action)) throw new Error('User id is missing');
        const { userId, data } = action;
        const { user_set } = draft.account;
        const userIndex = user_set.findIndex((u) => u.id === userId);
        draft.account.user_set[userIndex] = {
          ...user_set[userIndex],
          ...data,
        };
        break;
      }
      case Action.CREATE_NEW_BUSINESS_PHONE: {
        if (!('businessPhone' in action)) throw new Error('business phone id is missing');
        draft.account.business_phones.push(action.businessPhone);
        break;
      }
      case Action.UPDATE_BUSINESS_PHONE: {
        if (!('id' in action)) throw new Error('business phone id is missing');
        if (!('is_enabled_for_call_rescue' in action)) {
          throw new Error('business is_enabled_for_call_rescue is missing');
        }
        const { id, is_enabled_for_call_rescue } = action;
        const index = draft.account.business_phones.findIndex(
          (businessPhone) => businessPhone.id === id
        );
        if (index === -1) {
          throw new Error('business was not found.');
        }
        draft.account.business_phones[index].is_enabled_for_call_rescue =
          is_enabled_for_call_rescue;
        break;
      }
      case Action.CREATE_NEW_USER: {
        if (!('user' in action)) throw new Error('user is missing');
        draft.account.user_set.push(action.user);
        break;
      }
      case Action.UPDATE_ACCOUNT_NAME: {
        if (!('name' in action)) throw new Error('Name is missing');
        draft.account.name = action.name;
        break;
      }
      case Action.UPDATE_TWILIO_CONFIGURATION: {
        if (!('twilio_configuration' in action)) throw new Error('Configuration is missing');
        draft.account.twilio_configuration = action.twilio_configuration;
        break;
      }
      case Action.UPDATE_BILLING_SETTING: {
        if (!('billingSetting' in action)) throw new Error('Billing setting is missing');
        draft.account.billing_setting = action.billingSetting;
        break;
      }
      default:
        throw new Error('Unexpected object');
    }
  },
  initialState
);

export const useAccountProfileReducer = (): [StateType, Dispatch<ActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
